import { Api } from "@/api/Api";
import { type CrossSectionCreate, type CrossSectionSchemaOutput, LayoutType } from "@mm/metx-workbench.meteomatics.com";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createCrossSection = createAsyncThunk(
  "api/crossSection/create",
  async (payLoad: { data: CrossSectionCreate; layoutId: number }, _thunkAPI) => {
    return await Api.crossSection
      .v2CreateCrossSection({
        crossSectionCreate: payLoad.data,
      })
      .then((crossSection: CrossSectionSchemaOutput) => {
        return { tool: crossSection, layoutType: LayoutType.CrossSection, layoutId: payLoad.layoutId };
      });
  },
);
